import React from 'react'
import { Box, Breadcrumbs, Link, Typography } from '@mui/material'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'
import { useNavigate } from 'react-router-dom'

interface BreadcrumbItem {
    label: string
    to?: string
}

interface ContentBreadcrumbsProps {
    items: BreadcrumbItem[]
}

const ContentBreadcrumbs: React.FC<ContentBreadcrumbsProps> = ({ items = [] }) => {
    const navigate = useNavigate()

    if (!items.length) {
        return null
    }

    return (
        <Box sx={{ px: 0.5, pb: 1.5 }}>
            <Breadcrumbs
                aria-label='content-breadcrumbs'
                separator={<NavigateNextIcon fontSize='small' />}
            >
                {items.map((item, index) => {
                    const isLast = index === items.length - 1

                    if (isLast || !item.to) {
                        return (
                            <Typography
                                key={`${item.label}-${index}`}
                                color='text.primary'
                                variant='body2'
                                sx={{ fontWeight: 600 }}
                            >
                                {item.label}
                            </Typography>
                        )
                    }

                    return (
                        <Link
                            key={`${item.label}-${index}`}
                            underline='hover'
                            color='inherit'
                            variant='body2'
                            sx={{ cursor: 'pointer' }}
                            onClick={(event) => {
                                event.preventDefault()
                                if (item.to) {
                                    navigate(item.to)
                                }
                            }}
                        >
                            {item.label}
                        </Link>
                    )
                })}
            </Breadcrumbs>
        </Box>
    )
}

export { ContentBreadcrumbs }
